<template>
  <section>
    <TitleBar>
      Communications envoy&eacute;es
      <template #toolbar-content>
        <TableButtonGroup
          :tableKey="tableKey"
          @rechercher="rechercher"
        ></TableButtonGroup>
      </template>
    </TitleBar>
    <b-container fluid>
      <ErrorComponent :error="error" @hide="error = null"></ErrorComponent>
      <StrapiEditoComponent></StrapiEditoComponent>
      <PaginatedTable
        :fields="fields"
        :busy="busy"
        :pageable="pageable"
        :page="page"
        @change="pageableChanged"
      >
        <template #cell(expand)="row">
          <ToggleRowComponent :row="row" @toggle="toggleDetails(row)">
            Afficher les d&eacute;tails
          </ToggleRowComponent>
        </template>
        <template #row-details="{ item }">
          {{ item }}
        </template>
        <template #cell(modifieLe)="{ item }">
          {{ isoSqlInstantToFrenchInstant(item.modifieLe) }}
        </template>
        <!-- TODO Implémenter la ligne de détails ! -->
      </PaginatedTable>
    </b-container>
  </section>
</template>

<script>
import TitleBar from "../../components/TitleBar.vue";
import TableButtonGroup from "../../components/controls/TableButtonGroup.vue";
import ErrorComponent from "../../components/ErrorComponent.vue";
import StrapiEditoComponent from "../../components/strapi/StrapiEditoComponent.vue";
import PaginatedTable from "../../components/PaginatedTable.vue";
import ToggleRowComponent from "../../components/controls/ToggleRowComponent.vue";
import CommunicationService from "../../services/communication.service";
import { TableKeys } from "../../store/tables.defaults";
import {
  dataFactory as tableDataFactory,
  created,
  computed as tableComputed,
  methods as tableMethods,
} from "../../services/tables.service";
import UtilsService from "../../services/utils.service";
export default {
  name: "HistoriqueView",
  components: {
    TitleBar,
    TableButtonGroup,
    ErrorComponent,
    StrapiEditoComponent,
    PaginatedTable,
    ToggleRowComponent,
  },
  data() {
    return {
      ...tableDataFactory(TableKeys.COM_HISTORIQUES),
      error: null,
      templates: [],
      page: null,
    };
  },
  computed: {
    ...tableComputed,
    societe() {
      return this.$store.getters['societe'].code;
    },
  },
  created,
  async mounted() {
    await this.loadTemplates();
    await this.load();
  },
  methods: {
    ...tableMethods,
    isoSqlInstantToFrenchInstant(instant) {
      return UtilsService.isoSqlInstantToFrenchInstant(instant);
    },
    async loadTemplates() {
      this.error = null;
      try {
        let { data } = await CommunicationService.searchTemplatesMail(
          this.societe,
          { genericFilters: { operation: "$and", operands: [] } }
        );
        this.templates = data.content;
      } catch (error) {
        this.templates = [];
        this.error = UtilsService.handleError(error);
      } finally {
        this.busy = false;
      }
    },
    async load() {
      this.error = null;
      try {
        this.busy = true;
        let { data } = await CommunicationService.searchHistoriques(
          this.societe,
          this.getSearchPayload()
        );
        data.content.forEach((c) => {
          c.template = this.templates.find((t) => t.id === c.idTemplate);
          c.details = false;
        });
        this.page = data;
      } catch (error) {
        this.page = null;
        this.error = UtilsService.handleError(error);
      } finally {
        this.busy = false;
      }
    },
    async toggleDetails(row) {
      if (!row.item.details) {
        try {
          let { data: communication } =
            await CommunicationService.getCommunication(row.item.id);
          row.item.filtres = communication.filtres;
          row.item.contacts = communication.contacts;
          row.item.contenus = communication.contenus;
          row.item.details = true;
        } catch (error) {
          this.error = UtilsService.handleError(error);
        }
      }
      row.toggleDetails();
    },
  },
};
</script>
